import React from 'react';
import blanketLogo from '../assets/blanket-logo.png';

interface BlanketLogoProps {
  className?: string;
}

export const BlanketLogo: React.FC<BlanketLogoProps> = ({
  className = 'h-8 w-auto',
}) => (
  <img src={blanketLogo} alt="Blanket" className={className} />
);
